import { FC, useLayoutEffect, useRef } from 'react'
import DataModel from '../models/dataModel'
import styles from './css/PromoCsMoney.module.css'
import { useTypedSelector } from '../hooks/useTypedSelector'

const PromoCsMoney: FC = () => {
	const ref = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		ref.current.style.setProperty('padding', '0', 'important')
	}, [])

	const { current: currLang } = useTypedSelector(x => x.lang)

	if (currLang === 0) {
	} else {
	}

	const listOfBanner = currLang === 0 ? ['banner_ru'] : ['banner_en']
	const randImage = Math.floor(Math.random() * listOfBanner.length)
	const bannerName = listOfBanner[randImage]

	// Instant Sell у CS.MONEY переехал: /market/instant-sell/ → /market/sell/
	// const url = `https://cs.money/market/sell/` +
	// 	`?utm_source=mediabuy&utm_medium=vvtable&utm_campaign=instantsell&utm_content=${bannerName}`
	// Партнёрская ссылка на раздел Sell (P2P) — ровно в том виде, что прислал CS.MONEY
	const url = `https://cs.money/market/p2p-sell/?utm_source=mediabuy&utm_medium=vvtable&utm_campaign=season_5&utm_content=banner`
	return (
		<div className={styles.container} ref={ref}>
			<a href={url} target={'_blank'} rel={'nofollow'}>
				<img src={`Resources/promo/csmoney/28072026/${bannerName}.png?v1`} />
			</a>
		</div>
	)
}

export default PromoCsMoney
